import { render, staticRenderFns } from "./ButtonItem.vue?vue&type=template&id=7f159180&scoped=true&"
import script from "./ButtonItem.vue?vue&type=script&lang=js&"
export * from "./ButtonItem.vue?vue&type=script&lang=js&"
import style0 from "./ButtonItem.vue?vue&type=style&index=0&id=7f159180&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f159180",
  null
  
)

export default component.exports